import {useEffect,useState} from 'react';
import {Link} from '../ui/ScopedLink';
type Result={documentId:string;exact:boolean;comparison:null|{relationship:string;reason:string;differences:string[];evidence:{incoming:string;retained:string}[]}};
type Resolution={id:string;decision:string;reason:string;results:Result[];canRestore:boolean};
export function DocumentCopyResolution({itemId,load,restore}:{itemId:string;load:()=>Promise<{resolution:Resolution|null}>;restore:(id:string)=>Promise<void>}){
 const [resolution,setResolution]=useState<Resolution|null>(),[error,setError]=useState(''),[busy,setBusy]=useState(false);
 useEffect(()=>{let current=true;setResolution(undefined);setError('');void load().then(result=>{if(current)setResolution(result.resolution);})
  .catch(()=>{if(current)setError('The automatic comparison could not be loaded.');});return()=>{current=false;};},[itemId]);
 if(error)return <p role="alert">{error}</p>;
 if(!resolution)return null;
 return <section aria-label="Automatic document comparison">
  <h3>Automatic comparison: {resolution.decision}</h3><p>{resolution.reason}</p>
  {resolution.results.map(result=><div key={result.documentId}>
   <Link to={'/documents/'+result.documentId}>Open retained document</Link>
   {result.exact?<p>The original files are identical.</p>:result.comparison?<>
    <p>{result.comparison.relationship}: {result.comparison.reason}</p>
    {result.comparison.differences.length>0&&<ul>{result.comparison.differences.map((difference,index)=><li key={index}>{difference}</li>)}</ul>}
    <details><summary>Compared evidence</summary>{result.comparison.evidence.map((e,index)=><div key={index}>
     <p>Incoming: {e.incoming}</p><p>Retained: {e.retained}</p>
    </div>)}</details>
   </>:<p>A complete comparison was not available. Review the originals.</p>}
  </div>)}
  {resolution.canRestore&&<><p>This copy is excluded from pending filing. Its original and receipt history are retained.</p>
   <button disabled={busy} onClick={async()=>{setBusy(true);setError('');try{await restore(resolution.id);setResolution(null);}
    catch{setError('The copy could not be restored. Refresh and try again.');}finally{setBusy(false);}}}>Restore to filing review</button></>}
 </section>;
}
